// Small helpers shared by the Customer 360 panels.

export function statusClass(status) {
  const s = String(status || "").toUpperCase().trim();
  if (s === "SUBMITTED") return "bg-yellow-100 text-yellow-800";
  if (s === "QUOTE") return "bg-slate-100 text-slate-700";
  if (s === "ENTERED" || s === "IN PROCESS") return "bg-blue-100 text-blue-800";
  if (s === "PROCESSED") return "bg-indigo-100 text-indigo-800";
  if (s === "PICKED") return "bg-purple-100 text-purple-800";
  if (s.includes("READY")) return "bg-teal-100 text-teal-800";
  if (s.includes("SHIPPED") || s.includes("INVOICED")) return "bg-green-100 text-green-800";
  if (s.includes("BACK ORDER")) return "bg-amber-100 text-amber-800";
  if (s === "CANCELLED") return "bg-red-100 text-red-700";
  return "bg-slate-100 text-slate-600";
}

/** Currency with cents, e.g. $1,234.50 */
export function fmtMoney(n) {
  return Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

/** Product cost in New Taiwan dollars — always labelled NT$, never mixed with USD. */
export function fmtNtd(n, dp = 2) {
  if (n == null || !Number.isFinite(Number(n))) return "—";
  return `NT$${Number(n).toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp })}`;
}

/** USD in cost contexts — labelled US$ so it is never mistaken for NTD. */
export function fmtUsdCost(n, dp = 2) {
  if (n == null || !Number.isFinite(Number(n))) return "—";
  return `US$${Number(n).toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp })}`;
}

export function daysAgoLabel(d) {
  if (!d) return "never";
  const t = new Date(d).getTime();
  if (!Number.isFinite(t)) return "—";
  const days = Math.floor((Date.now() - t) / 86_400_000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  if (days < 365) return `${Math.round(days / 30)} mo ago`;
  return `${(days / 365).toFixed(1)} yr ago`;
}

export const CHANNEL_LABELS = {
  phone: "Call",
  email: "Email",
  "email-smtp": "Email",
  meeting: "Meeting",
  visit: "Visit",
  text: "Text",
  other: "Other",
};

export function channelLabel(ch) {
  return CHANNEL_LABELS[String(ch || "").toLowerCase()] || "Contact";
}

export function errMsg(e, fallback) {
  return e?.message || e?.error || fallback || "Something went wrong";
}

/** Open one customer's page in a new browser tab, leaving the page you came from as it is. */
export function openCustomerInNewTab(accountId) {
  // A clicked target=_blank link opens a tab; window.open with a features
  // string can open a separate popup window instead.
  const a = document.createElement("a");
  a.href = `${window.location.origin}${process.env.PUBLIC_URL || ""}/?customer=${encodeURIComponent(accountId)}`;
  a.target = "_blank";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
